import { memo } from 'react';
import { ModalExtendedProps } from '@bonanza-social/navigation';
import StatusRetention from '../components/StatusRetention/StatusRetention';
import StatusModal from '../components/StatusModal/StatusModal';

function StatusRetentionModal({ close }: ModalExtendedProps) {
  return (
    <StatusModal close={close}>
      <StatusRetention flex={1} onButtonPress={close} />
    </StatusModal>
  );
}

export default memo(StatusRetentionModal);
